import {
  getIsPreOrder,
  getPurchaseStatus,
  maybeHasGreatDealTag
} from '@/SearchResults/ResultTileV2/helpers/ResultTile.helpers';
import { useDeliveryOrPickupTagInfo } from '@/SearchResults/ResultTileV2/hooks';
import { useTileDataContext } from '~/contexts/TileDataContext';
import usePriceDrop from '~/hooks/usePriceDrop';
import AvailabilityTag from './AvailabilityTag';
import GreatDealTag from './GreatDealTag';
import NewPriceTag from './NewPriceTag';
import OnHoldTag from './OnHoldTag';
import Tag from './Tag';

const Tags = () => {
  const { showTag: showAvailabilityTag, textToDisplay } =
    useDeliveryOrPickupTagInfo();
  const { tileData } = useTileDataContext();
  const showPreOrderTag = getIsPreOrder(tileData);
  const showGreatDeal = maybeHasGreatDealTag(tileData);
  const { isLocked: showLockedTag, isOnHold: showOnHoldTag } =
    getPurchaseStatus(tileData);
  const { getPriceDrop } = usePriceDrop();
  const { showPriceDrop } = getPriceDrop(tileData);

  return (
    <div className="absolute flex gap-4 left-[8px] top-[8px]">
      {showOnHoldTag && <OnHoldTag />}
      {showPreOrderTag && <Tag text="Pre-Order Now" bgColor="bg-blue-2" />}
      {showLockedTag && (
        <Tag
          text="Purchase in Progress"
          bgColor="bg-red-2"
          data-qa="text-only-locked"
        />
      )}
      {showPriceDrop && <NewPriceTag />}
      {showGreatDeal && <GreatDealTag />}
      {showAvailabilityTag && <AvailabilityTag textToDisplay={textToDisplay} />}
    </div>
  );
};

export default Tags;
